/* eslint-disable react/prop-types */
import React from 'react';
import { List, Table, Checkbox, Button } from 'antd';
import { generateFields } from 'modules/templates/components/TemplateEditor/helper';
import { CopyFilled, DeleteFilled } from '@ant-design/icons';
import classes from './List.module.scss';

export const ListWorkmanship = (props) => {
  const { value, field } = props;
  const { config } = field || {};
  const { configs: subFieldConfigs, itemFields: subFields } = config;
  const generated = generateFields(subFields, subFieldConfigs);

  return (
    <List
      className={classes.list}
      dataSource={value}
      renderItem={(itemFields, index) => {
        const alphabet = String.fromCharCode(97 + index);
        const subValue = itemFields.reduce((acc, subField) => {
          acc[subField.name] = subField.value;
          return acc;
        }, {});
        return (
          <List.Item className={classes.item}>
            <span>Defect</span>
            <div className={classes.item__wrapper}>
              <span className={classes.item__list_style}>#{alphabet}</span>
              <Table
                className={classes.item__table}
                size="small"
                style={{ width: '100%' }}
                bordered={false}
                dataSource={subValue ? [subValue] : []}
                pagination={false}
                columns={[
                  {
                    title: '',
                    width: 50,
                    render: () => {
                      return (
                        <span className={classes.item__table__actions}>
                          <Button disabled type="text" size="small" icon={<CopyFilled />} />
                          <Button
                            disabled
                            ghost
                            type="text"
                            danger
                            size="small"
                            icon={<DeleteFilled />}
                          />
                        </span>
                      );
                    },
                  },
                  {
                    title: 'Defect Name',
                    width: 250,
                    dataIndex: 'defectName',
                    render(data) {
                      return <span className={classes.item__table__title}>{data}</span>;
                    },
                  },
                  {
                    title: 'Defect Group',
                    dataIndex: 'defectGroup',
                    render(data) {
                      return <span className={classes.item__table__title}>{data}</span>;
                    },
                  },
                  {
                    title: 'Defect Classification',
                    width: 295,
                    render: () => {
                      const fieldConfig = generated.find(({ name }) => {
                        const subFieldName = Array.isArray(name) ? name.join('.') : name;
                        return subFieldName.includes('defectClassification');
                      });
                      const subField = itemFields.find(({ name }) => {
                        const subFieldName = Array.isArray(name) ? name.join('.') : name;
                        return subFieldName.includes('defectClassification');
                      });
                      return (
                        <div>
                          {fieldConfig.config.options.map((option) => {
                            const checked = subField.options.find((picked) => {
                              return picked.value === option.value;
                            });
                            return (
                              <Checkbox
                                disabled
                                checked={!!checked}
                                value={option.value}
                                key={option.value}>
                                {option.label}
                              </Checkbox>
                            );
                          })}
                        </div>
                      );
                    },
                  },
                  {
                    title: 'Reference Media',
                    width: 120,
                    render: () => {
                      const subField = itemFields.find(({ name }) => {
                        const subFieldName = Array.isArray(name) ? name.join('.') : name;
                        return subFieldName.includes('referenceMedia');
                      });
                      return (
                        <Checkbox disabled checked={subField.optional}>
                          Optional
                        </Checkbox>
                      );
                    },
                  },
                  {
                    title: 'Quantity',
                    width: 150,
                    render: () => {
                      const subField = generated.find(({ name }) => {
                        const subFieldName = Array.isArray(name) ? name.join('.') : name;
                        return subFieldName.includes('quantity');
                      });
                      return (
                        <span className={classes.item__table__description}>
                          {subField.description}
                        </span>
                      );
                    },
                  },
                  {
                    title: 'Description',
                    render: () => {
                      const subField = generated.find(({ name }) => {
                        const subFieldName = Array.isArray(name) ? name.join('.') : name;
                        return subFieldName.includes('description');
                      });
                      return (
                        <span className={classes.item__table__description}>
                          {subField.description}
                        </span>
                      );
                    },
                  },
                ]}
              />
            </div>
          </List.Item>
        );
      }}
    />
  );
};
